import { Fragment } from "react";
import Col from "react-bootstrap/Col";
import { ListGroup } from "react-bootstrap";

export const AdminExternalLinkElement = () => {
  return (
    <Fragment>
      <Col>
        <ListGroup className={"axis-link-list"}>
          <ListGroup.Item
            className={"text-axis-offblack"}
            action={true}
            href={
              "https://bhsct.allocate-cloud.co.uk/BankStaffBHSCTLIVE/(S(ofs2rk1znuckjs0ri51coccs))/UserLogin.aspx"
            }
          >
            RN - Belfast Trust
          </ListGroup.Item>
          <ListGroup.Item
            className={"text-axis-offblack"}
            action={true}
            href={
              "https://bhsct.allocate-cloud.co.uk/BankStaffBHSCTLIVE/(S(ofs2rk1znuckjs0ri51coccs))/UserLogin.aspx"
            }
          >
            HCA - Belfast Trust
          </ListGroup.Item>
        </ListGroup>
      </Col>
      <Col>
        <ListGroup className={"axis-link-list"}>
          <ListGroup.Item
            className={"text-axis-offblack"}
            action={true}
            href={
              "https://shsc.allocate-cloud.co.uk/BankStaffSHSCLIVE/(S(kcwyo5gg3htmfoyapdztprz0))/UserLogin.aspx"
            }
          >
            RN - Southern Trust
          </ListGroup.Item>
          <ListGroup.Item
            className={"text-axis-offblack"}
            action={true}
            href={
              "https://shsc.allocate-cloud.co.uk/BankStaffSHSCLIVE/(S(kcwyo5gg3htmfoyapdztprz0))/UserLogin.aspx"
            }
          >
            HCA - Southern Trust
          </ListGroup.Item>
        </ListGroup>
      </Col>
      <Col>
        <ListGroup className={"axis-link-list"}>
          <ListGroup.Item
            className={"text-axis-offblack"}
            action={true}
            href={
              "https://sehsc.allocate-cloud.co.uk/BankStaffSEHSCLIVE/(S(x2nfuqgsmx2lohhxtwa4gfp4))/UserLogin.aspx"
            }
          >
            RN - Southeastern Trust
          </ListGroup.Item>
          <ListGroup.Item
            className={"text-axis-offblack"}
            action={true}
            href={
              "https://sehsc.allocate-cloud.co.uk/BankStaffSEHSCLIVE/(S(x2nfuqgsmx2lohhxtwa4gfp4))/UserLogin.aspx"
            }
          >
            HCA - Southeastern Trust
          </ListGroup.Item>
        </ListGroup>
      </Col>
      <Col>
        <ListGroup className={"axis-link-list"}>
          <ListGroup.Item
            className={"text-axis-offblack"}
            action={true}
            href={"#"}
          >
            RN - Northern Trust
          </ListGroup.Item>
          <ListGroup.Item
            className={"text-axis-offblack"}
            action={true}
            href={"#"}
          >
            HCA - Northern Trust
          </ListGroup.Item>
        </ListGroup>
      </Col>
      <Col>
        <ListGroup className={"axis-link-list"}>
          <ListGroup.Item
            className={"text-axis-offblack"}
            action={true}
            href={"#"}
          >
            RN - Western Trust
          </ListGroup.Item>
          <ListGroup.Item
            className={"text-axis-offblack"}
            action={true}
            href={"#"}
          >
            HCA - Western Trust
          </ListGroup.Item>
        </ListGroup>
      </Col>
    </Fragment>
  );
};
